import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { getFileIconType } from './fileIconUtils';

interface FileIconProps {
  fileName?: string | null;
  className?: string;
  size?: 'sm' | 'md';
}

const sizeClasses = { sm: 'w-8 h-8', md: 'w-10 h-10' };

export const FileIcon: React.FC<FileIconProps> = ({ fileName, className = '', size = 'md' }) => {
  const { colors } = useTheme();
  const type = getFileIconType(fileName);
  const s = sizeClasses[size];

  const typeStyles = {
    pdf: colors.error,
    image: colors.success,
    doc: colors.info,
    sheet: colors.success,
    generic: cn(colors.surfaceHover, colors.textMuted),
  }[type];

  return (
    <div
      className={cn('flex-shrink-0 flex items-center justify-center rounded-lg', s, typeStyles, className)}
      aria-hidden
    >
      {type === 'pdf' && (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2 5 5h-5V4zm-3 8v2h6v-2h-6zm0 4v2h4v-2h-4z" />
        </svg>
      )}
      {type === 'image' && (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      )}
      {(type === 'doc' || type === 'generic') && (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )}
      {type === 'sheet' && (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      )}
    </div>
  );
};

export default FileIcon;
